import React from 'react';
import IafsTable from './IafsTable';

function EnergyRecurringIafsTable({ iafs }) {
  return (
    <IafsTable
      title="Compensi da ricorrenze energia"
      iafs={iafs}
      anchorId="iafs-recurring-energy"
    />
  );
}

export default EnergyRecurringIafsTable;
